import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../Style.css";
import PartnerlistWithPayout from "./PartnerlistWithPayout";
import { Button, Checkbox, message, Radio } from "antd";
import LanlistWithPayout from "./LanlistWithPayout";
import { use } from "react";
import { datasocurceLanPayout } from "../helper/payoutdatasample";
import { connect } from "react-redux";
import Logout from "../../../containers/Pages/Login/Logout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addholdRemarkAction,
  addReamapRemarkAction,
  addRecoveryRemarkAction,
  getPricingPartnerdata,
  payoutLandataAction,
  payoutPartnerLansearch,
} from "../../../redux/PayoutLanData/Action";
import { partnerDataSuccess } from "../../../redux/PricingPartnerDetails/PricingPartnerDetailsAction";
import { cache } from "react";
import useSession from "../../CustomLogout/useSession";
import { Modal } from "antd";
import { Space } from "antd";
import { Table } from "antd";
import { Input } from "antd";
import { BellOutlined, DeleteOutlined, EditOutlined, LeftCircleOutlined, PlusCircleOutlined, SaveOutlined, SearchOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import { generateMiscellaneousAction, miscellaneousListSuccess, removeMiscellaneousAction } from "../../../redux/PayoutMiscellaneous/Action";
import moment, { max } from "moment";
import { Form } from "antd";
import { Tooltip } from "antd";
import { debounce } from "lodash";










const LanListbypartner = (props) => {
  const [form] = Form.useForm();
  const [landatasource, setLanDatasource] = useState([]);
  const [makerAction, setMakerAction] = useState(false);
  const [checkerAction, setCheckerAction] = useState(false);
  const [radiostate, setRadioState] = useState("All");
  const [recovry, setRecovry] = useState(false);
  const [unhold, setUnhold] = useState(false);
  const [mAdjustment, setmAdjustment] = useState(false);
  const [ismAdjustment, setismAdjustment] = useState(false);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [ismAdjustmentMod, setismAdjustmentMod] = useState(false);
  const [remap, setRemap] = useState(false);
  const [CreditAmount, setCreditAmount] = useState('');
  const [DebitAmount, setDebitAmount] = useState('');
  const [ReferenceNumber, setReferenceNumber] = useState('');
  const [ReferenceDate, setReferenceDate] = useState(null);
  const [Description, setDescription] = useState('');
  const [entryData, setEntryData] = useState([]);
  const [rows, setRows] = useState([]);
  const [fileApprovalId, setFileApprovalId] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({ Check: [] });
  const navigate = useNavigate();
  const handleSessionExpired = useSession();
  const location = useLocation(); 
  const ReportId = location.state?.ReportId;
  const partnerId = location.state?.partnerId;
  const partnerName = location.state?.partnerFirmName || "partner Name";
  const [partnerList, setPartnerList] = useState([]);
  const [adjustmentUpdate, setAdjustmentUpdate] = useState(false);
  const [adjustmentId , setAdjustmentId] = useState(null);
  const [adjustmentTrack,setAdjustmentTrack] = useState(null);
  const [downloadAction, setDownloadAction] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100', '200'],
  });

  useEffect(() => {
    handleRadioChange(radiostate);
  }, [radiostate]);

   useEffect(() => {
    if (CreditAmount !== '' && parseFloat(CreditAmount) > 0) {
      setDebitAmount('0');
      // form.setFieldValue('DebitAmt', '0'); // Reset DebitAmount to 0
    } else if (DebitAmount !== '' && parseFloat(DebitAmount) > 0) {
      setCreditAmount('0');
      // form.setFieldValue('CreditAmt', '0'); // Reset CreditAmount to 0
    }
  }, [CreditAmount, DebitAmount]);

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const options = [
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          ALL
        </div>
      ),
      value: "All",
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Regular Cases
        </div>
      ),
      value: "REGULAR",
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Remap Cases
        </div>
      ),
      value: "REMAP",
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Cases on Hold
        </div>
      ),
      value: "ONHOLD",
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Recovery
        </div>
      ),
      value: "RECOVERY",
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Retrospective Adjustment
        </div>
      ),
      value: "RETRO",
    },

    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Miscellaneous Entry
        </div>
      ),
      value: "MANUALADJUSTMENT",
    },
  ];

  useEffect(() => {
  }, [selectedCheckboxes]);

  const handleCheckboxChange = (e, column, rowId) => {
    const isChecked = e.target.checked;
    setSelectedCheckboxes((prevState) => {
      const newState = { ...prevState };
      if (isChecked) {
        newState[column] = [...newState[column], rowId];
      } else {
        newState[column] = newState[column].filter((item) => item !== rowId);
      }
      return newState;
    });
  };

  const handelAddReamapRemark = async (data) => {
    try {
      const res = await props.addReamapAction({
        accessToken: props.accessToken,
        Remapdata: data,
      });

      const errorCode = res?.data?.error?.errorCode || res.errorCode;
      if (
        errorCode &&
        errorCode === 403 &&
        (res?.data?.error?.errorCode || res.errorCode)
      ) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }

      return res;
    } catch (error) {
      return error;
    }
  };

  const handelAddholdRemark = async (data) => {
    try {
      const reshold = await props.addholdAction({
        accessToken: props.accessToken,
        holdData: data,
      });
      const errorCode = reshold?.data?.error?.errorCode || reshold.errorCode;
      if (
        errorCode &&
        errorCode === 403 &&
        (reshold?.data?.error?.errorCode || reshold.errorCode)
      ) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }
      return reshold;
    } catch (error) {
      console.error("Error adding reamap remark:", error);
      return error;
    }
  };

  const handleAddRecoveryRemark = async (data) => {
    try {
      const res = await props.addRecoveryRemarkAction({
        accessToken: props.accessToken,
        recoveryData: data,
      });

      const errorCode = res?.data?.error?.errorCode || res.errorCode;
      if (
        errorCode &&
        errorCode === 403 &&
        (res?.data?.error?.errorCode || res.errorCode)
      ) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }

      return res;
    } catch (error) {
      console.error("Error adding recovry remark:", error);
      return error;
    }
  };


  const partnerList2 = useMemo(async () => {
    const partnerdata = props.getPartnerList({
      accessToken: props.accessToken,
    });
    const respartnerdata = await partnerdata;
    const errorCode =
      respartnerdata?.data?.error?.errorCode || respartnerdata.errorCode;
    if (
      errorCode &&
      errorCode === 403 &&
      (respartnerdata?.data?.error?.errorCode || respartnerdata.errorCode)
    ) {
      handleSessionExpired(); //Logout the user if session expired
      return;
    }
      return respartnerdata;
    }, [props.accessToken, props.getPartnerList]);
  
    useEffect(() => {
      partnerList2.then((data) => {
        if (data) {
          setPartnerList(data);
        }
      });
    }, [partnerList2]);

  
  const fetchPaginatedData = async (lanStag) => {
    setDownloading(true);
    try{
  // Initialize pagination parameters
  let current = 1;
  let pageSize = 10;

  // Declare 'response' and 'data' variables outside the if/else blocks
  // to ensure they are accessible throughout the function's scope.
  let response;
  let data = []; // Initialize data to an empty array

  if (lanStag === "MANUALADJUSTMENT") {
    response = await props.miscellaneousListSuccess({
      accessToken: props.accessToken,
      partnerId: partnerId,
      reportId: ReportId,
    });
  } else {
    response = await props.payoutLanDataSuccess({
      accessToken: props.accessToken,
      reportId: ReportId,
      partnerId: partnerId,
      tab: lanStag,
      page: current,
      records: pageSize,
    });
  }


  const errorCode =
    response?.response?.data?.error?.errorCode || response?.response?.status;

  if (
    errorCode &&
    errorCode === "403" &&
    (response?.response?.data?.error?.errorCode || response?.response?.status)
  ) {
    handleSessionExpired(); // Logout the user if session expired
    return;
  }

  // Assign data based on lanStag.
  // 'data' is now declared once at the top of the function.
  if (lanStag === "MANUALADJUSTMENT") {
    data = response || [];
  } else {
    data = response.payoutLanReport || [];
  }
  setFileApprovalId(response?.reportStageId)
  setPagination((prev) => ({
    ...prev,
    current,
    pageSize,
    total: response?.totalElements,
  }));

  if (lanStag == "REGULAR") {
    // No action specified for REGULAR, but setPartnerList is cleared otherwise.
     partnerList2.then((data) => {
          if (data) {
            setPartnerList(data);
          }
        });
  } else if (lanStag == "REMAP"){
    // No action specified for REMAP, but setPartnerList is cleared otherwise.
     partnerList2.then((data) => {
          if (data) {
            setPartnerList(data);
          }
        });
  }else {
    setPartnerList([]);
  }

  if (lanStag === "RECOVERY") {
    setRecovry(true);
  } else {
    setRecovry(false);
  }

  if (lanStag === "REMAP") {
    setRemap(true);
  } else {
    setRemap(false);
  }

  if (lanStag === "ONHOLD") {
    setUnhold(true);
  } else {
    setUnhold(false);
  }

  if (lanStag === "MANUALADJUSTMENT") {
    setmAdjustment(true);
    setismAdjustmentMod(false);

    const mapdata = data.map((item, index) => ({
      srNo: index + 1,
      ReferenceNumber: item.referenceNumber || "",
      ReferenceDate: item.referenceDate ? item.referenceDate : null,
      Description: item.comments || "",
      CreditAmt: item.creditAmount || 0,
      DebitAmt: item.debitAmount || 0,
      adjustmentId: item.adjustmentId,
      partnerId: item.partnerId,
      adjustmentDate: item.adjustmentDate ? item.adjustmentDate : null,
      isDeleted: item.isDeleted,
    }));
    setEntryData(mapdata); 
    setRows([]);
   
  } else {
    setmAdjustment(false);
    setLanDatasource(data); 
  }

  setMakerAction( lanStag === "All" || lanStag === "REGULAR" );
  setDownloadAction(lanStag === "All");
  setCheckerAction(lanStag === "REGULAR");
  setSelectedCheckboxes({ Check: [] });
  setRadioState(lanStag);

    } catch (error) {
      console.error("Error in fetchPaginatedData:", error);
    } finally{
      setDownloading(false);
    }
}


  const handlePageChange = async (page, pageSize, lanStag) => {
    // Call the API with the new page and pageSize
    const payoutPartnerResponse = await props.payoutLanDataSuccess({
      accessToken: props.accessToken,
      reportId: ReportId,
      partnerId: partnerId,
      tab: lanStag,
      page: page,
      records: pageSize,
    });
    const res = payoutPartnerResponse;
    setLanDatasource(res.payoutLanReport || []);
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize,
      total: res?.totalElements,
    }));
    // setPagination((prev) => ({
    //   ...prev,
    //   total: res?.totalElements,
    // }));
  };

  const handleRadioChange = async (value, data = datasocurceLanPayout) => {
    switch (value) {
      case "All":
        fetchPaginatedData("All");
        break;

      case "REGULAR":
        fetchPaginatedData("REGULAR");
         
        break;

      case "RECOVERY":
        fetchPaginatedData("RECOVERY");
        break;

      case "REMAP":
        fetchPaginatedData("REMAP");
      
        break;

      case "ONHOLD":
        fetchPaginatedData("ONHOLD");
        break;

      case "RETRO":
        fetchPaginatedData("RETRO");
        break;

      case "MANUALADJUSTMENT":
        fetchPaginatedData("MANUALADJUSTMENT");
        break;

      default:
        break;
    }
  };

 
 


  const handelAddMaualAadjustment = () => {
    form.resetFields();
    // setismAdjustment(true);
    setismAdjustmentMod(true);
    // setRows([]);
    // Reset the form fields
    setCreditAmount("");
    setDebitAmount("");
    setDescription("");
    setReferenceNumber("");
    setReferenceDate(null);
    setAdjustmentUpdate(false);
  
  };

 
const handleRemove =  (index) => {

  const data = entryData[index];
  if (data.adjustmentId) {
    // If adjustmentId exists, remove the entry from the backend
    props.removeMiscellaneous({
      accessToken: props.accessToken,
      adjustmentId: data.adjustmentId,
    }).then((response) => {
      if (response.status === 200) {
        message.success("Entry removed successfully!");
         fetchPaginatedData("MANUALADJUSTMENT");
      } else {
        message.error("Failed to remove entry.");
      }
    }).catch((error) => {
      console.error("Error removing entry:", error);
      message.error("Error removing entry.");
    });
  }else {
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
    setEntryData((prev) => prev.filter((_, i) => i !== index)); 
  }
  
    
  }

  // const handleEdit = (index) => {
  //   // setismAdjustment(true);
  //   let rowToEdit = null;
  //   let entryToEdit = null;
  //   setismAdjustmentMod(true);
  //   if (rows.length>0){

  //      rowToEdit = rows[index];
  //       console.log("Row to edit:", rowToEdit);
  //   }else{
  //      entryToEdit = entryData[index];
  //        console.log("entryData to edit:", entryToEdit);
  //   }
    
   
   
  //   if (rowToEdit) {
  //     setReferenceNumber(rowToEdit.ReferenceNumber);
  //     setReferenceDate(rowToEdit.ReferenceDate ? rowToEdit.ReferenceDate : null);
  //     setDescription(rowToEdit.Description);
  //     setCreditAmount(rowToEdit.CreditAmount);
  //     setDebitAmount(rowToEdit.DebitAmount);
  //     // Optionally, you can remove the row from the list if you want to edit it
  //     // handleRemove(index);
  //   }else if (entryToEdit && entryToEdit.adjustmentId) {
  //     setReferenceNumber(entryToEdit.ReferenceNumber);
  //     console.log("ReferenceDate:", entryToEdit.ReferenceDate);
      
  //     handleDateChange(entryToEdit.ReferenceDate ? moment(entryToEdit.ReferenceDate, "DD-MM-YYYY") : null, "DD-MM-YYYY");
  //     setDescription(entryToEdit.Description);
  //     setCreditAmount(entryToEdit.CreditAmt);
  //     setDebitAmount(entryToEdit.DebitAmt);
  //     setAdjustmentId(entryToEdit.adjustmentId);
  //     setAdjustmentUpdate(true)
  //   } 

  // }
//  

const handleEdit = (index, source) => {
    setismAdjustmentMod(true); 
     
     

    let rowToEdit = null;
    let entryToEdit = null;

    if (source === 'rows') {
      rowToEdit = entryData[index];
      if (rowToEdit) {

   
        setReferenceNumber(rowToEdit.ReferenceNumber);
        setReferenceDate(rowToEdit.ReferenceDate ? moment(rowToEdit.ReferenceDate, "DD-MM-YYYY") : null);
        setDescription(rowToEdit.Description);
        setCreditAmount(rowToEdit.CreditAmount);
        setDebitAmount(rowToEdit.DebitAmount);
        setAdjustmentId(null); 
        setAdjustmentTrack(rowToEdit.trackingId);
        setAdjustmentUpdate(true); 
      }
    } else if (source === 'entryData') {
      entryToEdit = entryData[index];
      if (entryToEdit && entryToEdit.adjustmentId) {

           form.setFieldsValue({
      ReferenceNumber: entryToEdit.ReferenceNumber || '',
      ReferenceDate: entryToEdit.ReferenceDate ? moment(entryToEdit.ReferenceDate, "DD-MM-YYYY") : null,
      Description: entryToEdit.Description || '',
   
    });
        setReferenceNumber(entryToEdit.ReferenceNumber);
        
        handleDateChange(entryToEdit.ReferenceDate ? moment(entryToEdit.ReferenceDate, "DD-MM-YYYY") : null, "DD-MM-YYYY");
        setDescription(entryToEdit.Description);
        setCreditAmount(entryToEdit.CreditAmt); 
        setDebitAmount(entryToEdit.DebitAmt);
        setAdjustmentId(entryToEdit.adjustmentId);
        setAdjustmentUpdate(true); 
        setAdjustmentTrack(null);
      }
    }
  };

const handleDateChange = (date, dateString) => {
  

    setReferenceDate(date); // Store the moment object in state
   
  };

  const handleAdd = () => {
    if(ReferenceNumber === '' || Description === '' || (CreditAmount === '' && DebitAmount === '') || ReferenceDate === null) {
      message.error("Please fill all the fields.");
      return;
    }
    const guid = () => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    };
  if (!ReferenceNumber || !Description || (!CreditAmount && !DebitAmount)) return;
  if (CreditAmount>0 && DebitAmount >0) {
    message.error("Please enter either Credit Amount or Debit Amount zero, not both.");
    return;
  }
  
  const track = guid();

  setRows([
    ...rows,
    { ReferenceNumber, ReferenceDate, Description, CreditAmount, DebitAmount, trackingId: track }
  ]);

  setEntryData((prev) => [
    ...prev,
    {
      srNo: prev.length + 1,
      ReferenceNumber,
      ReferenceDate: ReferenceDate ? ReferenceDate.format("DD-MM-YYYY") : "",
      Description,
      CreditAmt: CreditAmount,
      DebitAmt: DebitAmount,
      trackingId: track,
    },
  ]);

  // Clear input fields
  setReferenceNumber('');
  setDescription('');
  setCreditAmount('');
  setDebitAmount('');
  // setismAdjustment(false);
  setismAdjustmentMod(false);
  message.success("Entry added successfully!");

};

const handleUpdateAdjustment = async ()=>{

  if (adjustmentId===null){
     
  //  entryData.map((data)=>{
  //    if()
  //  })

  }
  const currentDate = new Date().toISOString().slice(0, 10);
     const payloaddata =[{
      adjustmentId:adjustmentId,
      partnerId: partnerId,
      partnerReportId: ReportId,
      referenceNumber :ReferenceNumber ,
      referenceDate : ReferenceDate ? ReferenceDate.format("YYYY-MM-DD") : "",
      comments : Description,
      creditAmount :  String(CreditAmount),
      debitAmount :  String(DebitAmount),
      adjustmentDate : currentDate,
      isDeleted : false

     }]
    
    const adjustmentData = await props.addMiscellaneousAction({
      accessToken: props.accessToken,
      Data: payloaddata,
      partnerId: partnerId,
    });
    const errorCode = adjustmentData?.data?.error?.errorCode || adjustmentData.errorCode;
    if (
      errorCode &&
      errorCode === 403 &&
      (adjustmentData?.data?.error?.errorCode || adjustmentData.errorCode)
    ) {
      handleSessionExpired(); //Logout the user if session expired
      return;
    }
    if (adjustmentData?.status === 200) {
      message.success("Adjustment submitted successfully!");
      form.resetFields();
      setAdjustmentUpdate(true);
      setismAdjustmentMod(false);
      setRows([]);
      fetchPaginatedData("MANUALADJUSTMENT");
     
    } else {
      message.error("Failed to submit adjustment.");
    }
    
}

const handleModalCancel = () => { 
  form.resetFields();
  setismAdjustmentMod(false);
  // setRows([]);
  setReferenceNumber('');
  setDescription('');
  setCreditAmount('');
  setDebitAmount('');
  setReferenceDate(null);
  setAdjustmentUpdate(false);
  setAdjustmentId(null);
  setAdjustmentTrack(null);

}

  const handleSubmitAdjustment = async () => {
    const currentDate = new Date().toISOString().slice(0, 10);
    const payloaddata = rows.map(data => ({
     
      partnerId: partnerId,
      partnerReportId: ReportId,
      referenceNumber :data.ReferenceNumber ,
      referenceDate : data.ReferenceDate ? data.ReferenceDate.format("YYYY-MM-DD") : "",
      comments : data.Description,
      creditAmount : data.CreditAmount,
      debitAmount : data.DebitAmount,
      adjustmentDate : currentDate,
      isDeleted : false

    }));
    
    const adjustmentData = await props.addMiscellaneousAction({
      accessToken: props.accessToken,
      Data: payloaddata,
      partnerId: partnerId,
    });
    const errorCode = adjustmentData?.data?.error?.errorCode || adjustmentData.errorCode;
    if (
      errorCode &&
      errorCode === 403 &&
      (adjustmentData?.data?.error?.errorCode || adjustmentData.errorCode)
    ) {
      handleSessionExpired(); //Logout the user if session expired
      return;
    }
    if (adjustmentData?.status === 200) {
      message.success("Adjustment submitted successfully!");
      setismAdjustmentMod(false);
      setRows([]);
      fetchPaginatedData("MANUALADJUSTMENT");
     
    } else {
      message.error("Failed to submit adjustment.");
    }
   
  };



  const debouncedSearch = useMemo(() => 
  debounce(async (value) => {
    const searchValue = String(value || "").trim().toLowerCase();
    
  
    if (!searchValue) {
      setPagination(prev => ({
        ...prev,
        current: 1,
        pageSize: 10,
      }));
      await fetchPaginatedData(radiostate);
      return;
    }

    try {
     
      // setLoading?.(true);
      
    
      let response = await props.payoutPartnerLansearch({
        accessToken: props.accessToken,
        reportId: ReportId,
        lanTab: radiostate,
        lanNo: searchValue,
        partnerId: partnerId
      });
      
      
     
      if (!response || response?.payoutLanReport.length === 0) {
        response = await props.payoutPartnerLansearch({
          accessToken: props.accessToken,
          reportId: ReportId,
          lanTab: radiostate,
          applicantName: searchValue,
          partnerId: partnerId
        });
      }
      
    
      const searchData = response || [];
      const lanReportData = searchData.payoutLanReport || [];
      
      
    
      setLanDatasource(lanReportData);
      
     
      const totalResults = lanReportData.length;
      setPagination(prev => ({
        ...prev,
        current: 1,
        total: totalResults,
        pageSize: totalResults > 0 ? totalResults : 10, 
      }));
      
      
      
    } catch (error) {
      console.error("Search error:", error);
      message.error("Search failed. Please try again.");
      
      // Optional: Reset to original data on error
      // await fetchPaginatedData(radiostate);
      
    } finally {
      // setLoading?.(false);
    }
  }, 300), 
  [props.accessToken, ReportId, radiostate, partnerId] 
);


useEffect(() => {
  return () => {
    debouncedSearch.cancel();
  };
}, [debouncedSearch]);


    const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTextTable(value);
    debouncedSearch(value);
  };



  return (
    <div className="" style={{ maxWidth: "100%" }}>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            <Button
                type="default"
                style={{
                  margin: "0",
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px', // space between icon and text
                  padding: '0 8px',
                  color:'#00b1b1',
                }}
                onClick={() => navigate(-1)}
              >
                <LeftCircleOutlined />
                <span>Back</span>
              </Button>
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                      props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                      props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      {/* <Row>
        <div style={{ display: "flex" }}>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col
              md={6}
              style={{ display: "flex", margin: 10 }}
              className="btn-partner"
            >
              <div>
                <Button
                  className="ant-btn ant-btn-default "
                  type="primary"
                  style={{ marginLeft: 5, width: 200, backgroundColor: '#1b8593', color: '#fff', fontSize: '0.9rem', padding: 10, borderRadius: '5px', border: 'none' }}
                >
                  Advance Search
                </Button>
              </div>
            </Col>
          </Col>
        </div>
      </Row> */}

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Col md={6} style={{ display: "flex" }} className="btn-partner">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 style={{ fontWeight: 700, fontSize: "0.9rem" }}>
                Partner :{" "}
                <span style={{ color: "#35cd7a" }}>{partnerName}</span>
              </h5>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ marginTop: 30, display: "flex" }}>
          <Col md={9}>
            <div
              className="buckets-container"
              style={{ width: "100%", overflowX: "auto", whiteSpace: "nowrap" }}
            >
              <Radio.Group
                block
                options={options}
                value={radiostate}
                onChange={(e) => {
                  handleRadioChange(e.target.value);
                }}
                optionType="button"
                buttonStyle="solid"
                buttonCheckedBg="#1b8593"
              />
            </div>
          </Col>
          <Col
            md={3}
            style={{
              display: "flex",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end",
              marginBottom: 7,
            }}
          >
            {/* {makerAction ? [<> <Button className='ant-btn ant-btn-default ' style={{ fontSize: '0.8rem', padding: 10, backgroundColor: '#1b8593', color: '#fff', margin: '3px', borderRadius: '5px' }} >Regenrate Report</Button>
              <Button className='ant-btn ant-btn-default ' style={{ marginLeft: 10, backgroundColor: '#1b8593', padding: 10, color: '#fff', fontSize: '0.8rem', margin: '3px', borderRadius: '5px' }}>Submit</Button>
            </>] : []} */}

            {mAdjustment ? (
              <>
                <Button
                  onClick={() => handelAddMaualAadjustment()}
                  className="ant-btn ant-btn-default "
                  style={{
                    fontSize: "0.8rem",
                    padding: 10,
                    backgroundColor: "#1b8593",
                    color: "#fff",
                    margin: "3px",
                    borderRadius: "5px",
                  }}
                >
                  <PlusCircleOutlined style={{ marginLeft: 5, marginBottom:3 }} />
                  Add Entry
                  
                </Button>

               { (rows.length>0) &&( <Button
                  onClick={() => handleSubmitAdjustment()}
                  className="ant-btn ant-btn-default "
                  style={{
                    fontSize: "0.8rem",
                    padding: 10,
                    backgroundColor: "#1b8593",
                    color: "#fff",
                    margin: "3px",
                    borderRadius: "5px",
                  }}
                >
                  <SaveOutlined style={{ marginLeft: 5, marginBottom:3 }} />
                 Save
                  
                </Button>)}

                <Modal
                  title="Add Manual Adjustment"
                  open={ismAdjustmentMod}
                  onCancel={() => handleModalCancel()}
                  width={800}
                  footer={false}
                >

                  <Form form = {form} layout="vertical" > 
                  <div style={{ marginBottom: 16 }}>
                    <Row gutter={[16, 16]}>
                       <Col span={8} >
                      <label>
                          <span style={{ color: "red", position: 'relative', top: '0', left: '100%', transform: 'translateX(-50%)', zIndex: 1 }}>
                            *
                          </span>
                          Reference Number
                      </label>
                      <Form.Item
                        name="ReferenceNumber"
                        rules={[{ required: true, message: 'Please input Reference Number!' }, { max: 60, message: 'Reference number cannot be more than 60 characters' }]}
                      >
                        <Input
                          placeholder="Reference Number"
                          type="text"
                          value={ReferenceNumber}
                          onChange={(e) => setReferenceNumber(e.target.value)}
                          name="ReferenceNumber"
                          required
                          maxLength={60}
                
                        />
                        </Form.Item>
                        </Col>

                        <Col span={8} > 
                        <label>
                          <span style={{ color: "red", position: 'relative', top: '0', left: '100%', transform: 'translateX(-50%)', zIndex: 1 }}>
                            *
                          </span>
                          Reference Date
                      </label>
                       <Form.Item  name="ReferenceDate"
                        rules={[{ required: true, message: 'Please select Reference Date!' }]}
                      >
                        <DatePicker
                          style={{ width: "100%", marginTop: 10 }}
                          format="DD-MM-YYYY"
                          name="ReferenceDate"
                          value={ReferenceDate}
                          onChange={handleDateChange}
                        />
                        </Form.Item>

                      </Col>
                      <Col span={8}>
                       <label>
                          <span style={{ color: "red", position: 'relative', top: '0', left: '100%', transform: 'translateX(-50%)', zIndex: 1 }}>
                            *
                          </span>
                          Credit Amount
                      </label>
                        
                        <Input
                          style={{marginLeft:"4%"}}
                          placeholder="Credit Amount"
                          type="number"
                          value={CreditAmount}
                           disabled={parseFloat(DebitAmount) > 0}
                          onChange={(e)=>  { setCreditAmount(e.target.value)}}                       
                          />
                      </Col>
                      <Col span={8}>
                       <label>
                          <span style={{ color: "red", position: 'relative', top: '0', left: '100%', transform: 'translateX(-50%)', zIndex: 1 }}>
                            *
                          </span>
                          Debit Amount
                      </label>
                        <Input
                          style={{marginLeft:"3%"}}
                          placeholder="Debit Amount"
                          type="number"
                          value={DebitAmount}
                          disabled={parseFloat(CreditAmount) > 0}
                          onChange={(e) => setDebitAmount(e.target.value)}
                        />
                      </Col>
                     
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                      <Col span={18}>
                       <label>
                          <span style={{ color: "red", position: 'relative', top: '0', left: '100%', transform: 'translateX(-50%)', zIndex: 1 }}>
                            *
                          </span>
                         Description
                      </label>
                      <Form.Item
                        name="Description"
                       rules={[{ required: true, message: 'Please input Description!' }, { max: 250, message: 'Description cannot be more than 250 characters' }]}
                      >
                        <Input.TextArea
                          placeholder="Description"
                          autoSize={{ minRows: 2, maxRows: 6 }}
                          style={{ width: "100%" }}
                           value={Description}
                          onChange={(e) => setDescription(e.target.value)}
                          maxLength={250}
                        />
                        </Form.Item>
                      </Col>
                      <Col
                        span={6}
                        style={{ display: "flex", alignItems: "stretch",  }}
                      >
                       {adjustmentUpdate ? 
                        (<Button
                          type="primary"
                          className="ant-btn ant-btn-default"
                          onClick={handleUpdateAdjustment}
                          style={{
                            background: "#1b8593",
                            color: "#fff",
                            fontSize: "0.8rem",
                            marginLeft: "10px",

                            borderRadius: "5px",
                            flote: "right",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                           Update
                        </Button>)

                        :
                        (<Button
                          type="primary"
                          className="ant-btn ant-btn-default"
                          onClick={handleAdd}
                          style={{
                            background: "#1b8593",
                            color: "#fff",
                            fontSize: "0.8rem",
                            marginLeft: "10px",

                            borderRadius: "5px",
                            flote: "right",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          + Add
                        </Button>)

                       
                       }
                      </Col>
                    </Row>
                  </div>
                  </Form>
                </Modal>
              </>
            ) : (
              []
            )}
          </Col>
        </div>
      </Row>

      <Row style={{ display: "flex" }}>
        {!mAdjustment? 
        <>
         <Col
            md={9}
            style={{
              display: "flex",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end",
            }}
          ></Col>
        <Col
            md={3}
            style={{
              display: "flex",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
            <Input
            //  disabled={!searchlandatasource.length}
              className="search-input"
              allowClear
              placeholder="Search..."
              suffix={<SearchOutlined  />}
          
              value={searchTextTable}
              onChange={handleSearch}
              style={{ width: 200 }}
            />
          </Col>
          
        <LanlistWithPayout
          landataSource={landatasource}
          // getpartnerList={handelgetpartnerList}
          partnerList={partnerList.length > 0 ? partnerList.sort((a, b) => {
  
                      if (a.pricingAdded === true && b.pricingAdded === false) {
                        return -1;
                      }
                      
                      if (a.pricingAdded === false && b.pricingAdded === true) {
                        return 1;
                      }
                    
                      return 0;
                    }) : []}
          partnerId={partnerId}
          makerAction={makerAction}
          checkerAction={checkerAction}
          fileApprovalId={fileApprovalId}
          setCheckerAction={setCheckerAction}
          setFileApprovalId={setFileApprovalId}
          setLanDatasource={setLanDatasource}
          handleRadioChange={handleRadioChange}
          radiostate={radiostate}
          setRadioState={setRadioState}
          handleCheckboxChange={handleCheckboxChange}
          selectedCheckboxes={selectedCheckboxes}
          setSelectedCheckboxes={setSelectedCheckboxes}
          handelAddRemap={handelAddReamapRemark}
          handelAddhold={handelAddholdRemark}
          fetchPaginatedData={fetchPaginatedData}
          recovry={recovry}
          remap={remap}
          unhold={unhold}
          mAdjustment={mAdjustment}
          handleAddRecoveryRemark={handleAddRecoveryRemark}
          pagination={pagination}
          onPageChange={handlePageChange}
          monthlyReportid={ReportId}
          downloadAction={downloadAction}
          setDownloadAction={setDownloadAction} 
          downloading={downloading}
        /> </>: <Col md={12}><div style={{ maxWidth: '100%' }}><Table
          dataSource={entryData}
          columns={[
            {
              title: "S. No",
              dataIndex: "srNo",
              key: "srNo",
              width: 70,
            },
            {
              title: "Reference Number",
              dataIndex: "ReferenceNumber",
              key: "ReferenceNumber",
            },
            {
              title: "Reference Date",
              dataIndex: "ReferenceDate",
              key: "ReferenceDate",
            },
            {
              title: "Description",
              dataIndex: "Description",
              key: "Description",
              width: 200,
              ellipsis: true,
              render: (text) => (
                <Tooltip title={text}>
                  <span>{text}</span>
                </Tooltip>
              ),
            },
            {
              title: "Credit Amount",
              dataIndex: "CreditAmt",
              key: "CreditAmt",
            },
            {
              title: "Debit Amount",
              dataIndex: "DebitAmt",
              key: "DebitAmt",
            },
            {
              title: "Action",
              key: "Action",
              render: (_, data, idx) => (<> <Button danger 
                onClick={() => handleRemove(idx)}>
                <DeleteOutlined />
                </Button>
               {data.adjustmentId && (<>|<Button info 
                onClick={() => handleEdit(idx, data?.adjustmentId?"entryData":"rows")}>
                <EditOutlined />
                </Button></>)}</>
               
              ),
            },
          ]}

          rowKey="srNo"
        // {...(ismAdjustment ? { components } : {})}

      Scroll={{ x:"max-content", y: "calc(100vh - 300px)" }}
        
      /></div> </Col>}

      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    payoutLanDataSuccess: (data) => dispatch(payoutLandataAction(data)),
    getPartnerList: (data) => dispatch(getPricingPartnerdata(data)),
    addReamapAction: (data) => dispatch(addReamapRemarkAction(data)),
    addholdAction: (data) => dispatch(addholdRemarkAction(data)),
    addRecoveryRemarkAction: (data) => dispatch(addRecoveryRemarkAction(data)),
    addMiscellaneousAction: (data) => dispatch(generateMiscellaneousAction(data)),
    miscellaneousListSuccess: (data) => dispatch(miscellaneousListSuccess(data)),
    removeMiscellaneous: (data) => dispatch(removeMiscellaneousAction(data)),
    payoutPartnerLansearch: (data) => dispatch(payoutPartnerLansearch(data))
    
  };
};

const mapStateToProps = (state) => {
  // console.log('stateData:', state.pricigPartner.state.partnerDetail);
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LanListbypartner);
